/**
 * Format licence/quotation `translationsRequested` entries for display.
 * Entries may be legacy "Country - Language" strings or Mongo Translation _id strings.
 */
export function formatTranslationsRequestedForDisplay(requested, translationsList = []) {
  if (!requested || !Array.isArray(requested) || !requested.length) return '';

  return requested
    .map((entry) => {
      if (entry == null) return '';
      const s = String(entry).trim();
      if (!s) return '';

      if (/^[a-fA-F0-9]{24}$/.test(s)) {
        const t = translationsList.find((x) => String(x._id || x.id) === s);
        if (!t) return s;
        const tag = (t.localeTag || '').trim();
        const lang = t.language || '';
        if (tag && lang) return `${lang} - ${tag}`;
        if (lang && t.country) return `${t.country} - ${lang}`;
        return lang || t.country || s;
      }

      if (typeof entry === 'object' && entry.country && entry.language) {
        const territory = entry.territory ? ` / ${entry.territory}` : '';
        return `${entry.country} - ${entry.language}${territory}`;
      }

      return s;
    })
    .filter(Boolean)
    .join(', ');
}
